import { ReactElement } from 'react';
import { Spin } from 'antd';
import Flexbox from '@common/components/Flexbox';
import * as Styled from './FullPageSpinnerLayout.styled';

const FullPageSpinnerLayout = (): ReactElement => {
  return (
    <>
      <Styled.FullPageSpinnerOuterContainerStyled data-test-id='full-page-spinner'>
        <Flexbox
          alignItems='center'
          justifyContent='center'
          style={{
            width: '100%',
            height: '100%',
            background: 'rgba(255 255 255 / 80%)',
          }}>
          <Spin size='large' />
        </Flexbox>
      </Styled.FullPageSpinnerOuterContainerStyled>
    </>
  );
};

export default FullPageSpinnerLayout;
